export default function () {
  $(document).ready(() => {
    // Swipe Feature using HammerJS
    $('.carousel-container').each(function () {
      const carousel = this.querySelector('.carousel');
      let touchPos = {};
      let scrollPos;
      carousel.addEventListener('touchstart', (e)=>{
        touchPos.X = e.touches[0].screenX;
        touchPos.Y = e.touches[0].screenY;
        scrollPos = window.scrollY;
      });

      carousel.addEventListener('touchmove', (e)=>{
        if(Math.abs(touchPos.X - e.touches[0].screenX)>Math.abs(touchPos.Y - e.touches[0].screenY))
        {
        } else {
          window.scrollTo(window.scrollX, scrollPos + touchPos.Y - e.touches[0].screenY);
        }
      });

      const manager = new Hammer.Manager(carousel);
      const Swipe = new Hammer.Swipe();
      manager.add(Swipe);

      manager.on('swipe', function(e) {
        var direction = e.offsetDirection;
        if (direction === 4 ) {
          $(carousel).parent().parent().find('.go-prev.carousel-arrow')
            .first()
            .click();
        }

        if (direction === 2) {
          $(carousel).parent().parent().find('.go-next.carousel-arrow')
            .first()
            .click();
        }
      });
    });

    /**
       * Change slides when arrow buttons are clicked
       */
    $('.arrow-button').not('.popup-arrow').each(function () {
      $(this).on('click', function () {
        let diff;
        const carouselID = $(this).parent().parent().parent()
          .attr('data-carousel');
        const slideList = $(`#${carouselID}`).find('.carousel').first();

        if ($(this).hasClass('go-next')) {
          diff = 1;
        } else if ($(this).hasClass('go-prev')) {
          diff = -1;
        }

        const positionText = $('#carousel-pos');
        let positionNum = parseInt(positionText.text()) + diff;

        if (positionNum < 1) {
          positionNum = slideList.children().length;
        } else if (positionNum > slideList.children().length) {
          positionNum = 1;
        }

        positionText.text(positionNum);

        const prevSlide = slideList.find('li[style="order: 1;"]').first();
        const nextSlide = diff === 1
          ? slideList.find('li[style="order: 2;"]').first()
          : slideList.find('li[style="order: 0;"]').first();

        updateBullet(prevSlide, nextSlide);
        moveSlider(slideList, diff, Math.abs(diff));
      });
    });

    /**
     * Allow bullets to affect slider selection
     */
    $('.bullet-button').each(function () {
      $(this).on('click', function () {
        if ($(this).attr('data-slide') == 'next-3') {
          const controls = $(this).parent();
          const allItems = controls.find('.bullet-button.option > button');

          const currentPage = controls.find('.active:lt(3)');
          let nextPage = currentPage.last().parent().nextAll().find('.inactive')
            .slice(0, 3);

          if (nextPage.length === 0) {
            nextPage = controls.find('.inactive:lt(3)');
          }

          allItems.removeClass('active').addClass('inactive').hide();
          nextPage.removeClass('inactive').addClass('active').show()
            .first()
            .focus();
          return;
        }

        const carousel = $(`#${$(this).attr('data-carousel')}`);
        const prevBullet = $(this).parent().find('button.current').first();
        const prevSlide = $(`#${$(prevBullet.parent()).attr('data-slide')}`);
        const nextSlide = $(`#${$(this).attr('data-slide')}`);

        const carouselID = carousel.attr('id');
        const target = `#current-bullet${carouselID.replace('carousel', '')}`;

        updateBullet(prevSlide, nextSlide);

        const newStart = Number($(nextSlide).prop('id').replace(/.*?(\d+)$/, '$1'));
        const oldStart = Number($(prevSlide).prop('id').replace(/.*?(\d+)$/, '$1'));

        const slideList = carousel.find('.carousel').first();

        const diff = newStart - oldStart;
        moveSlider(slideList, diff, Math.abs(diff));
      });
    });

    function moveSlider(carousel, diff, count) {
      if (count === 0) return;

      if (diff > 0) {
        carousel.removeClass('is-reversing');
      } else {
        carousel.addClass('is-reversing');
      }

      carousel.children().removeClass('current');
      carousel.children().attr('tabindex', '-1');
      carousel.children().find('a, button').attr('tabindex', '-1');

      count--;
      const len = carousel.children().length;
      carousel.children().each(function () {
        const slide = $(this);
        const order = Number(slide.css('order'));
        const pos = order + (diff < 0 ? 1 : -1);
        const newOrder = pos >= len ? 0 : pos < 0 ? len - 1 : pos;
        slide.css('order', newOrder);
      });

      const nextSlide = carousel.find('li[style="order: 1;"]').first();
      nextSlide.addClass('current');
      $(nextSlide).attr('tabindex', '0').focus();
      $(nextSlide).find('a, button').attr('tabindex', '0');

      carousel.removeClass('is-set');
      setTimeout((() => {
        carousel.addClass('is-set');
        moveSlider(carousel, diff, count);
      }), 50 / Math.abs(diff));
    }

    /**
     * Update the carousel bullets once a slide has changed
     * @param prevSlide
     * @param newSlide
     */
    function updateBullet(prevSlide, newSlide) {
      const prevID = prevSlide.attr('id');
      const newID = newSlide.attr('id');

      // Update the bullet for the slide we just left
      const prevBullet = $(`*[data-slide="${prevID}"]`).first();
      const prevPos = prevBullet.find('button').attr('data-pos');
      prevBullet.find('button').first().removeClass('current').attr('aria-label', `Go to item ${prevPos}`);

      const carouselID = prevBullet.attr('data-carousel');
      const target = `#current-bullet${carouselID.replace('carousel', '')}`;

      // Update the bullet for the slide we have moved to
      const newBullet = $(`*[data-slide="${newID}"]`).first();
      newBullet.find('button').first().addClass('current').attr('aria-label', 'Current Slide')
        .append($(target));
    }

    // Accessibility Features
    // Set the popFocusIn function as an event for the Modaal links. Timer required so changes occur after popup
    $('button.text-button.inline').each(function () {
      $(this).on('keypress', (e) => {
        if (e.which == 13) {
          setTimeout(() => {
            modalFocusIn();
          }, 800);
        }
      });
      $(this).on('click', (e) => {
        setTimeout(() => {
          modalFocusIn();
        }, 800);
      });
    });

    // Lock focus inside the Nav Menu
    function modalFocusIn() {
      // Element to return to when the user escapes
      const elementBeforeFocus = document.activeElement;

      $('.popup-content-holder').attr('tabindex', 0);

      const modaals = $('.modaal-content-container');

      let modal = null;
      let closeButton = null;

      // previous modal is still present during the transfer process
      if (modaals.length > 1) {
        modal = $('.modaal-content-container').eq(1)[0];
        closeButton = $('.modaal-close').eq(1)[0];
      } else {
        modal = $('.modaal-content-container').first()[0];
        closeButton = $('#modaal-close')[0];
      }

      // Make child elements tab-able, mark first and last elements for loop
      const focusElements = $(modal).children();

      const focusList = Array.prototype.slice.call(focusElements);
      focusList.push(closeButton);

      const firstTab = focusList[0];
      const lastTab = focusList[focusList.length - 1];

      focusElements.each(function () {
        $(this).attr('tabindex', 0);

        $(this).keydown((e) => {
          trapTabKey(e);
        });
      });

      $('.modaal-close').keydown((e) => {
        trapTabKey(e);
      }).click(() => {
        const alertSection = $('#alert-section');
        alertSection.children().remove();
        alertSection.append('<p>Previous Modal Closed.</p>');
        elementBeforeFocus.focus();
      });

      function trapTabKey(key) {
        if (key.keyCode === 9) {
          if (key.shiftKey) {
            if (document.activeElement === firstTab) {
              key.preventDefault();
              lastTab.focus();
            }
          } else if (document.activeElement === lastTab) {
            key.preventDefault();
            firstTab.focus();
          }
        }

        if (key.keyCode === 27) {
          const alertSection = $('#alert-section');
          alertSection.children().remove();
          alertSection.append('<p role="alert">Previous Modal Closed.</p>');
          elementBeforeFocus.focus();
        }
      }

      $('.modaal-content.modaal-focus').first().find('.popup-content-holder').first().focus();
    }

    /**
        * Allow the user to swap between modals with the popup arrow buttons
        */
    $('.popup-arrow').each(function () {
      $(this).on('click', function () {
        const direction = $(this).attr('data-direction');
        const slide = $(this).attr('data-slide');
        const carousel = $(`#${$(this).attr('data-carousel')}`);
        const slideCount = carousel.children().length;

        const currentPos = parseInt($(this).attr('data-pos'));

        const nextPos = incrementPosition(slide, direction, currentPos, slideCount);

        // Close previous modal after the new one has opened
        setTimeout(() => {
          // $('#' + slide + '-' +  currentPos).find('.inline').first().modaal('close');
          $('#modaal-close').click();
          $(`#${slide}-${nextPos}`).find('.inline').first().click();
          $('body').css({ overflow: 'hidden' });
        }, 200);

        // Prevent the scrollbar from appearing then disappearing during the transition
        setTimeout(() => {
          $('body').addClass('modaal-noscroll').css({ overflow: '' });
        }, 1350);

        setTimeout(() => {
          modalFocusIn();
        }, 500);

        let alertSection = $('#alert-section');
        alertSection.children().remove();
        alertSection.append('<p role="alert">New modal opened</p>');
      });
    });

    /**
       * Select the next available slide to use for the modal
       * @param slide
       * @param direction
       * @param currentPos
       * @param slideCount
       * @returns {number}
       */
    function incrementPosition(slide, direction, currentPos, slideCount) {
      let nextPos = 0;

      if (direction == '>') {
        if (currentPos == slideCount) {
          nextPos = 1;
        } else {
          nextPos = currentPos + 1;
        }
      } else if (currentPos == 1) {
        nextPos = slideCount;
      } else {
        nextPos = currentPos - 1;
      }

      const nextSlide = $(`#${slide}-${nextPos}`);

      if (nextSlide.find('.inline').length == 0) {
        nextPos = incrementPosition(slide, direction, nextPos, slideCount);
      }

      return nextPos;
    }
  });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/gallery-carousel.js